module.exports = "/_next/static/images/Hero@2x-7d1a5c895270209a3cf5f484ca360459.webp";